module.exports = __webpack_public_path__ + "img/Retail2.ecb919c7.png";